import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Row, Col, Table, Button, Form, Card, FormCheck } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STORE_DEMANDS } from "../../../constants";
import { RouteComponentProps } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { DemandsStore, DemandPosition } from "../../../stores";
import { formatDate, formatMoney, formatShortDate } from "../../../common/Formatting";
import { TableFooterPager } from "../../../common/UI/TableFooterPager";
import { NotificationLevel } from "../../../stores/NotificationStore";
import { ReleaseModal } from "./ReleaseModal";
import { wrapCheckbox, wrapInput } from "../../../common/FormChangeWrapper";
import { DropdownList } from "react-widgets";
import { ShortCustomerOrderModal } from "../SharedComponents/ShortCustomerOrderModal";
registerLocale('ru', ru)

interface IProps {
    history: any,
    [STORE_DEMANDS]: DemandsStore
}

interface IState {
    currentPage: number,
    filterFormIsOpened: boolean,
    dateFrom?: Date,
    dateTo?: Date,
    selectedPositionsIds: number[],
    releaseModalIsOpened: boolean,
    orderDetailsModalIsOpened: boolean,
    selectedDeliveryPointId?: number,
    selectedOrderGuid: string
}


type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_DEMANDS)
@observer
export class DemandsPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const page = parseInt(this.props.match.params.page) || 1;
        this.state = {
            currentPage: page,
            filterFormIsOpened: false,
            selectedPositionsIds: [],
            releaseModalIsOpened: false,
            orderDetailsModalIsOpened: false,
            selectedDeliveryPointId: -1,
            selectedOrderGuid: ""
        };
    }

    demandsStore = (this.props as any)[STORE_DEMANDS] as DemandsStore;

    loadData = () => {
        this.demandsStore.loadDemands(this.state.currentPage, this.state.dateFrom, this.state.dateTo, this.state.selectedDeliveryPointId);
    }

    componentDidMount() {
        this.loadData();
        this.demandsStore.loadDeliveryPoints();
    }

    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        const prevPage = parseInt(prevProps.match.params.page) || 1;
        const page = parseInt(this.props.match.params.page) || 1;

        if (prevPage != page) {
            this.setState({
                currentPage: page
            }, () => {
                this.loadData();
            })
        }
    }


    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            dateFrom: undefined,
            dateTo: undefined,
            selectedDeliveryPointId: -1
        });
        localStorage.removeItem("demandsFilter");
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        }, () => {
            // this.saveFilterToLocalStorage();
        });
    }

    private onCheckPosition = (fieldName: string, value: string, checked: boolean) => {

        let newSelectedPositions = this.state.selectedPositionsIds;
        const posId = parseInt(value);
        if (posId == -1) {
            if (checked) {
                newSelectedPositions = this.demandsStore.demands.filter(w => !w.isReleased && w.allowRelease).map(w => w.id);
            }
            else
                newSelectedPositions = [];
        }
        else
            if (checked)
                newSelectedPositions.push(posId);
            else {
                newSelectedPositions.splice(newSelectedPositions.indexOf(posId), 1);
            }

        this.setState({
            selectedPositionsIds: newSelectedPositions
        })
    }

    private openReleaseModal = () => {
        if (this.state.selectedPositionsIds.length <= 0)
            this.demandsStore._rootStore.notificationStore.addNotification("Не выбрано ни одной позиции", NotificationLevel.error);
        else {
            const selectedPositions = this.demandsStore.demands.filter(w => this.state.selectedPositionsIds.indexOf(w.id) > -1).map(w => w.customerId);
            const differentUsers = selectedPositions.filter((v, i, a) => a.indexOf(v) === i);
            if (differentUsers.length > 1)
                this.demandsStore._rootStore.notificationStore.addNotification("Выбраны позиции разных клиентов", NotificationLevel.error);
            else
                this.setState({
                    releaseModalIsOpened: true
                })
        }
    }
    private closeReleaseModal = () => {
        this.setState({
            releaseModalIsOpened: false
        })
    }
    private sendReadyNotify = (position: DemandPosition) => {
        if (window.confirm(`Отправка уведомления по заказу № ${position.orderNumber}! Продолжить?`))
            this.demandsStore.sendReadyNotifies([position.id]);
    }
    private sendReadyNotifications = () => {
        const selectedPositions = this.demandsStore.demands
            .filter(w => this.state.selectedPositionsIds.indexOf(w.id) > -1 && !w.notifySended)
            .map(w => w.id);

        if (this.state.selectedPositionsIds.length <= 0) {
            this.demandsStore._rootStore.notificationStore.addNotification("Не выбрано ни одного заказа!", NotificationLevel.error);
            return;
        }

        if (selectedPositions.length <= 0) {
            this.demandsStore._rootStore.notificationStore.addNotification("По выбранным заказам уведомления уже отправлены!", NotificationLevel.error);
            return;
        }

        if (window.confirm(`Отправка уведомления по выбранным заказам! Продолжить?`)) {
            this.demandsStore.sendReadyNotifies(selectedPositions);
        }
    }



    render() {
        return [
            <TablePageHeader header="Отгрузки" reload={this.loadData} key="1">
                <Row>
                    <Col sm={8}>
                        <Form inline onSubmit={(e: any) => {
                            e.preventDefault();
                            this.loadData();
                        }}>

                            <Button type="button" size="sm" onClick={this.openReleaseModal}>
                                <FontAwesomeIcon icon="plus" />
                                {' '}
                                Отгрузить
                            </Button>
                            <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened}
                                style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                                Фильтр
                            </Button>
                        </Form>
                    </Col>
                    <Col sm={4} className="text-right">
                        <Button type="button" size="sm" onClick={this.sendReadyNotifications}>
                            <FontAwesomeIcon icon="sms" />
                            {' '}
                                Отправить уведомления о готовности
                            </Button>
                    </Col>
                </Row>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={this.loadData}>Найти</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>

                                        </Col>
                                        <Col sm="2">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        {this.demandsStore._rootStore.authStore.isInRole("FullAccessManager") ?
                                            <Col sm="4">
                                                <Form.Group controlId="filterForm.DeliveryPointId" className="col-md-12">
                                                    <Form.Label>Точка выдачи</Form.Label>
                                                    <div>
                                                        <DropdownList
                                                            data={[{ id: -1, fullName: "Не указано" }, ...this.demandsStore.deliveryPoints]}
                                                            name="selectedDeliveryPointId"
                                                            textField="fullName"
                                                            valueField="id"
                                                            filter='contains'
                                                            value={this.state.selectedDeliveryPointId}
                                                            onChange={(value: any) => this.changeFilter("selectedDeliveryPointId", value.id)}
                                                            placeholder="Выберите точку выдачи..."
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            : []}
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row> : [],
            <Row key="2">
                <Col sm={12}>
                    <Table bordered striped className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">
                                    <FormCheck type="checkbox"
                                        value={"-1"}
                                        checked={this.state.selectedPositionsIds.length > 0
                                            && this.state.selectedPositionsIds.length >= this.demandsStore.demands.filter(w => !w.isReleased).length}
                                        onChange={wrapCheckbox(this.onCheckPosition)}
                                    />
                                </th>
                                <th className="text-center">Номер заказа</th>
                                <th className="text-center">Дата создания</th>
                                <th className="text-center">Точка выдачи</th>
                                <th className="text-center">Клиент</th>
                                <th className="text-center">Статус</th>
                                <th className="text-center">Бренд</th>
                                <th className="text-center">Артикул</th>
                                <th>Описание</th>
                                <th className="text-center">Поставщик</th>
                                <th className="text-center">Срок</th>
                                <th className="text-center">Цена</th>
                                <th className="text-center">Количество</th>
                                <th className="text-center">Принято</th>
                                <th></th>
                            </tr>
                        </thead>
                        <TableFooterPager
                            columnsCount={9}
                            page={this.demandsStore.currentPage}
                            totalCount={this.demandsStore.totalOrdersCount}
                            pageSize={40}
                            move={"/sales/demands"} />
                        <tbody>
                            {this.demandsStore.demands.map((w, index) => <tr key={index} className={w.isReleased ? 'table-success' : w.allowRelease ? 'table-info' : ''}>
                                <td className="text-center">
                                    {w.isReleased || !w.allowRelease ? [] : <FormCheck type="checkbox"
                                        value={w.id.toString()}
                                        checked={this.state.selectedPositionsIds.indexOf(w.id) > -1}
                                        onChange={wrapCheckbox(this.onCheckPosition)}
                                    />}
                                </td>
                                <td className="text-center">
                                    <a href="javascript:void(0)" onClick={() => {
                                        this.setState({
                                            orderDetailsModalIsOpened: true,
                                            selectedOrderGuid: w.orderGuid
                                        });
                                    }} style={{ cursor: "pointer" }}>{w.orderNumber}</a>
                                </td>
                                <td className="text-center">{formatDate(w.dateCreated)}</td>
                                <td className="text-center" style={{
                                    maxWidth: "200px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }} title={w.deliveryPointName}>{w.deliveryPointName}</td>
                                <td className="text-center">{`${w.customerName || "фио не указано"}, тел. ${w.customerPhone}`}</td>
                                <td className="text-center">{
                                    (w.isReleased && w.releaseDate != undefined) ? `Выдан ${formatDate(w.releaseDate)}` :
                                        w.statusName
                                }</td>
                                <td className="text-center">{w.brand}</td>
                                <td className="text-center">{w.article}</td>
                                <td>{w.description}</td>
                                <td className="text-center">{w.supplierName}</td>
                                <td className="text-center">{w.deliveryTimeString}</td>
                                <td className="text-center">{formatMoney(w.costSale)}</td>
                                <td className="text-center">{w.count}</td>
                                <td className="text-center">{w.acceptedCount}</td>
                                <td className="text-center">
                                    {w.allowRelease && !w.isReleased && !w.notifySended ? <Button className="btn-xs" title="Отправить уведомление о готовности" onClick={() => this.sendReadyNotify(w)}>
                                        <FontAwesomeIcon icon="sms" />
                                    </Button> :
                                        (w.notifySended && w.notifyDate != undefined) ? <FontAwesomeIcon icon="sms" title={`Уведомление отправлено ${formatShortDate(w.notifyDate)}!`} /> : []}
                                </td>
                            </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row >,
            <ReleaseModal
                key={3}
                isOpened={this.state.releaseModalIsOpened}
                positions={this.demandsStore.demands.filter(w => this.state.selectedPositionsIds.indexOf(w.id) > -1)}
                cancelCallback={this.closeReleaseModal}
                savedCallback={() => this.setState({
                    releaseModalIsOpened: false,
                    selectedPositionsIds: []
                })}
            />,
            <ShortCustomerOrderModal
                key={4}
                isOpened={this.state.orderDetailsModalIsOpened}
                onClose={() => {
                    this.setState({
                        orderDetailsModalIsOpened: false
                    })
                }}
                orderGuid={this.state.selectedOrderGuid}
            />
        ]
    }

}